<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 mt-xl-0 pt-0 pt-md-3 pt-xl-1 pb-3 pb-md-5 pb-xl-2 shadow-lg col-12 col-lg-8"
>
  <div class="jumbotron-fluid mx-0 px-0 mb-0 pb-0">
    <div class="container mt-3 mb-2 mx-0 shadow-lg">
      <div class="row">
        <div class="col-12">
          <h4 class="rub-head4 text-info text-center font-weight-bold py-1">
            Confirm Loan
          </h4>
        </div>
      </div>
    </div>
    <div class="card-body mt-2 pt-3 mb-0 mx-0 pb-5 shadow-lg">
      <form [formGroup]="userForm">
        <div class="d-flex mt-0 mb-2 py-0 mx-auto">
          <div
            class="row"
            *ngIf="checkedClient"
          >
            <div class="col-12 text-left text-info h6"><strong>Selected Client Details</strong></div>
            <div class="col-6">ID: <strong>{{checkedClient.customerId}} </strong></div>
            <div class="col-6">Name: <strong>{{checkedClient.customerName}} </strong></div>
            <div class="col-6">Phone: <strong>{{checkedClient.customerPhone1}}</strong></div>
            <div class="col-6">Secret Pin: <strong>{{checkedClient.customerSecretPin}}</strong></div>
          </div>
        </div>
        <div class="d-flex mt-0 mb-2 py-0 mx-auto">
          <button
            type="button"
            class="btn btn-info col-5 mx-auto"
            (click)="selectFromData(dataModal, 100)"
          >
            Select Client
          </button>
          <button
            *ngIf="checkedClient"
            type="button"
            [hidden]="true"
            class="btn btn-info col-5 mx-auto"
            (click)="getStatement()"
          >
            Client's statement
          </button>
        </div>
        <div class="form-group text-primary">
          <label
            for="pin"
            [ngClass]="fval.pin.valid ? 'text-info' : ''"
          >CLIENT'S PIN<i
              *ngIf="fval.pin.valid"
              class="material-icons"
            >check_circle</i></label>

          <div class="input-group mb-0">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i
                  class="fas fa-lock text-primary mx-auto"
                  style="size: 50px"
                ></i>
              </div>
            </div>
            <input
              type="password"
              formControlName="pin"
              class="form-control"
              [ngClass]="{
                'is-invalid':
                  (fval.pin.touched || fval.pin.dirty) && fval.pin.errors
              }"
              placeholder="Enter your PIN"
              autocomplete="off"
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <i
                  class="fas"
                  [ngClass]="{
                  'fa-eye-slash': !fieldType,
                  'fa-eye': fieldType
                }"
                  (click)="toggleFieldType()"
                ></i>
              </span>
            </div>
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.required
            "
          >
            The PIN is required!
          </div>

          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.maxlength
            "
          >
            Please enter a valid pin!
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.hasNumber
            "
          >
            Only digits are allowed!
          </div>
          <div
            class="text-danger col"
            *ngIf="
              (fval.pin.touched || fval.pin.dirty) && fval.pin.errors?.minlength
            "
          >
            Please enter a valid pin!
          </div>
        </div>
        <div class="d-flex mt-1 mb-0 py-0 mx-auto">
          <button
            type="submit"
            class="btn btn-info col-5 mx-auto"
            [disabled]="!userForm.valid"
            (click)='postLoan()'
          >
            Confirm
          </button>
          <button
            type="button"
            class="btn btn-info col-5 mx-auto"
            routerLink='/townmanagement'
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
    <div class="d-flex mt-3 mb-2 mb-xl-0 py-2 mx-auto">
      <ngx-spinner
        class="bg-info"
        size="medium"
        type="ball-scale-multiple"
      >
        <p class="text-light">Please wait...</p>
      </ngx-spinner>
      <label
        class="col"
        *ngIf="errored"
        class="text-danger"
      >
        <!-- <i class="material-icons">Cancel</i> -->
        <ngx-alerts></ngx-alerts>
      </label>
      <label
        class="col"
        *ngIf="posted"
        class="text-info"
      >
        <!-- <i class="material-icons">check_circle</i> -->
        <ngx-alerts></ngx-alerts>
      </label>
    </div>
  </div>
</div>
<ng-template #dataModal>
  <app-data-modal
    [title]="modalTitle"
    [dataKind]="selectionKind"
    (result)="getResult($event)"
    [data]="selectionData"
    (close)="getClose($event)"
  ></app-data-modal>
</ng-template>
